module.exports = __webpack_public_path__ + "img/boucher_banner.9b6b2dd5.png";